export enum SkuPriceCollectionName {
  CLEARANCE = 'clearance',
  SEE_PRICE_IN_CART = 'seePriceInCart',
  DISCOUNTED = 'discounted',
  MARKDOWN = 'markdown',
  REGULAR = 'regular',
}
